import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_evonum_error_list = _resolveComponent("evonum-error-list")!

  return (_openBlock(), _createBlock(_component_evonum_error_list, {
    errors: _ctx.errors,
    dismiss: _ctx.dismiss
  }, null, 8, ["errors", "dismiss"]))
}